
export default {
  name: 'RosterDetailListActionsSnack',
  props: {
    addSnack: {
      type: Boolean,
      default: () => false
    },
    addSnackTitle: {
      type: String,
      default: 'Tambah Snack'
    },
    detailSnack: {
      type: Boolean,
      default: () => false
    },
    detailSnackTitle: {
      type: String,
      default: 'Lihat Detail Snack'
    },
    returnSnack: {
      type: Boolean,
      default: () => false
    },
    returnSnackTitle: {
      type: String,
      default: 'Kembalikan Snack'
    }
  }
}
